import { render, staticRenderFns } from "./ReportDetailsManageButtons.vue?vue&type=template&id=468aa310&scoped=true&"
import script from "./ReportDetailsManageButtons.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsManageButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468aa310",
  null
  
)

export default component.exports